import { Filter } from '@models/filters'

export const getFilterFromStoreFilter = (newFilter: Filter, storeFilter: any): Filter => {
    newFilter.categories.storeSpecs = {
        businessModel: storeFilter.business_model?.value || [],
        city: storeFilter.city?.value || [],
        country: storeFilter.country?.value || [],
        host: storeFilter.host?.value || [],
        macroregion: storeFilter.macroregion?.value || [],
        region: storeFilter.region?.value || [],
        segment: storeFilter.segment?.value || [],
        store: newFilter.categories?.storeSpecs?.store || [],
        storeHost: storeFilter.store_host_name?.value || [],
        storeLocation: storeFilter.store_location?.value || [],
        zone: storeFilter.zone_desc?.value || [],
        banner: (storeFilter.banner_desc?.value || []).map((b) => b.code) || [],
    }
    return newFilter
}

export const getFilterFromSmartFilter = (newFilter: Filter, smartFilter: any): Filter => {
    newFilter.categories.storeSpecs = {
        banner: smartFilter.bannerDesc[0]?.code
            ? smartFilter.bannerDesc.map((b) => b.code)
            : smartFilter.bannerDesc || [],
        businessModel: smartFilter.businessModel || [],
        city: smartFilter.city || [],
        country: smartFilter.country || [],
        host: smartFilter.host || [],
        macroregion: smartFilter.macroregion || [],
        region: smartFilter.region || [],
        segment: smartFilter.segment || [],
        store: [],
        storeHost: smartFilter.storeHostName || [],
        storeLocation: smartFilter.storeLocation || [],
        zone: smartFilter.zoneDesc || [],
    }
    return newFilter
}

export const getSmartFilterForDistribution = (storeSpec: any) => {
    return {
        bannerDesc: storeSpec.banner || [],
        businessModel: storeSpec.businessModel || [],
        city: storeSpec.city || [],
        country: storeSpec.country || [],
        host: storeSpec.host || [],
        macroregion: storeSpec.macroregion || [],
        region: storeSpec.region || [],
        segment: storeSpec.segment || [],
        storeHostName: storeSpec.storeHost || [],
        storeLocation: storeSpec.storeLocation || [],
        zoneDesc: storeSpec.zone || [],
    }
}
